import { render } from "./Stone.vue?vue&type=template&id=790bc18b"
import script from "./Stone.vue?vue&type=script&lang=js"
export * from "./Stone.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/utmtco-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__